import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import createReactClass from 'create-react-class'
import { Button } from '@lmc/ui-kit'

const ESC_KEYCODE = 27

export const Dropdown = createReactClass({
  displayName: 'Dropdown',
  propTypes: {
    alignright: PropTypes.bool,
    buttonHasDisclosureArrow: PropTypes.bool,
    buttonLabel: PropTypes.string,
    children: PropTypes.element,
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    items: PropTypes.array.isRequired,
    onSelect: PropTypes.func
  },
  getInitialState() {
    return {
      isOpen: this.props.isOpen || false
    }
  },
  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (typeof window === 'undefined') return
    if (nextState.isOpen) {
      window.addEventListener('keydown', this.handleKeyDown)
    } else {
      window.removeEventListener('keydown', this.handleKeyDown)
    }
  },
  openDropdown() {
    this.setState({ isOpen: true })
  },
  closeDropdown() {
    this.setState({ isOpen: false })
  },
  handleKeyDown(e) {
    if (e.keyCode === ESC_KEYCODE) {
      this.closeDropdown()
    }
  },
  handleHover(b) {
    if (this.props.onHover) {
      this.setState({ isOpen: b })
    }
  },

  renderChildren() {
    return React.Children.map(this.props.children, (child) =>
      React.cloneElement(child, {
        onClick: this.state.isOpen ? this.closeDropdown : this.openDropdown,
        className: classNames(child.props.className, 'Dropdown-toggle')
      })
    )
  },
  renderButton() {
    const { buttonHasDisclosureArrow = true } = this.props
    const disclosureArrow = buttonHasDisclosureArrow ? (
      <span className="disclosure-arrow" />
    ) : null

    return (
      <Button
        onClick={this.state.isOpen ? this.closeDropdown : this.openDropdown}
        className="Dropdown-toggle"
      >
        {this.props.buttonLabel}
        {disclosureArrow}
      </Button>
    )
  },
  onClick(selectedItem) {
    this.setState({
      isOpen: !this.state.isOpen
    })
    this.props.onSelect && this.props.onSelect(selectedItem)
  },
  renderDropdownMenu() {
    const self = this
    if (!this.state.isOpen) return null

    const dropdownMenuItems = this.props.items.map((item, i) => {
      let menuItem
      if (item.type === 'header') {
        menuItem = (
          <li key={`item-${i}`} className="Dropdown-menu__header">
            {item.label}
          </li>
        )
      } else if (item.type === 'divider') {
        menuItem = <li key={`item-${i}`} className="Dropdown-menu__divider" />
      } else {
        menuItem = (
          <li key={`item-${i}`} className="Dropdown-menu__item noselect">
            <span
              className="Dropdown-menu__action"
              onClick={self.onClick.bind(self, item.value)}
            >
              {item.label}
            </span>
          </li>
        )
      }
      return menuItem
    })

    return (
      <ul
        key="Dropdown-menu"
        className="Dropdown-menu"
        role="menu"
        onMouseLeave={() => this.handleHover(false)}
      >
        {dropdownMenuItems}
      </ul>
    )
  },
  renderDropdownMenuBackground() {
    if (!this.state.isOpen) return null
    return (
      <div className="Dropdown-menu-backdrop" onClick={this.closeDropdown} />
    )
  },
  render() {
    const { alignRight, onHover, ...restProps } = this.props

    // classes
    const dropdownClass = classNames(
      'Dropdown',
      {
        'is-open': this.state.isOpen,
        'align-right': alignRight
      },
      this.props.className
    )

    return (
      <span
        className={dropdownClass}
        {...restProps}
        onMouseEnter={() => this.handleHover(true)}
        style={{ cursor: 'pointer' }}
      >
        {React.Children.count(this.props.children)
          ? this.renderChildren()
          : this.renderButton()}
        {/* <CSSTransitionGroup transitionName="Dropdown-menu" transitionEnterTimeout={100} transitionLeaveTimeout={100}> */}
        {this.renderDropdownMenu()}
        {/* </CSSTransitionGroup> */}
        {this.renderDropdownMenuBackground()}
      </span>
    )
  }
})

export default Dropdown
